import log from 'loglevel';

log.setDefaultLevel(log.levels.INFO); // Set the default log level

export default log;